import React, {useEffect} from 'react'
import type {IContentItem} from '@kontent-ai/delivery-sdk'
import {useRouter} from 'next/router'
import type {Block} from '@/_new-code/services/kontent-ai/types'

export type PearCommerceWidgetContentItem = IContentItem<{
	// No specific elements needed for this component
}>

export const PearCommerceWidget: Block<PearCommerceWidgetContentItem> = () => {
	const router = useRouter()
	const pearCommerceId = '2667515212593122'

	useEffect(() => {
		const sku = router.query.sku

		if (!sku) return

		const existingScript = document.getElementById(
			'pearCommerceShoppableWidget'
		)
		if (existingScript) {
			existingScript.remove()
		}
		const existingIframe = document.getElementById('pear-pdp-target')
		if (existingIframe) {
			existingIframe.innerHTML = ''
		}

		const config = {
			vendorId: pearCommerceId,
			widget: 'retailer-list',
		}

		const script = document.createElement('script')
		script.id = 'pearCommerceShoppableWidget'
		script.type = 'text/javascript'
		script.text = `
			(function(e) {
				var s = document.createElement("script");
				s.type = "text/javascript";
				s.src = "https://offers.pearcommerce.com/js/sdk.js?config=" + encodeURIComponent(JSON.stringify(e));
				document.head.appendChild(s);
			})(${JSON.stringify(config)});
		`
		document.head.appendChild(script)
	}, [router.query.sku])

	return (
		<div
			data-kontent-element-codename="pear_commerce_widget_guidelines"
			id="pear-pdp-target"
		/>
	)
}
